export default "__VITE_ASSET__BaozHAAU__"